import React from 'react';
import CheckIcon from '@material-ui/icons/Check';

export const renderBooleanIcon = (value) =>
  value ? <CheckIcon fontSize="small" color="primary" /> : null;
